module.exports = __webpack_public_path__ + "static/media/user-access-security.cc8f4d38.svg";